export const SIRET_ERROR = 'Le SIRET doit contenir exactement 14 chiffres';

export const normalizeSiret = (value) => {
  if (value == null || value === '') return '';
  return String(value).replace(/\D/g, '').slice(0, 14);
};

export const isValidSiret = (value, { required = false } = {}) => {
  const digits = normalizeSiret(value);
  if (!digits) return !required;
  return digits.length === 14;
};
